import React from 'react';
import { useParams, Link } from 'react-router-dom';
import visaData from './visaData';
import './VisaDetails.css';

function VisaDetails() {
  const { visaId } = useParams();
  const visa = visaData.find((item) => item.id === visaId);

  if (!visa) {
    return (
      <section className="visa-details-page">
        <h1>Visa Not Found</h1>
        <p>The visa you are looking for does not exist.</p>
        <Link to="/visa" className="back-button">Back to Visa Assistance</Link>
      </section>
    );
  }

  return (
    <section className="visa-details-page">
      <div className="visa-details-container">
        <div
          className="visa-details-image"
          style={{ backgroundImage: `url(${visa.image})` }}
        ></div>
        <div className="visa-details-content">
          <h1>{visa.visa}</h1>
          <p>{visa.details}</p>
          <Link to={`/visa/enquiry/${visa.id}`} className="enquire-button">
            Enquire Now
          </Link>
        </div>
      </div>
      <Link to="/visa" className="back-button">← Back to Visa Assistance</Link>
    </section>
  );
}

export default VisaDetails;
